export default __webpack_public_path__ + "static/media/0129.a531f506.jpg";